/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  ContentRef,
  CustomizationAnnouncement,
  CustomizationBackground,
  CustomizationCorners,
  CustomizationDepth,
  CustomizationFavicon,
  CustomizationFooterGroup,
  CustomizationHeaderItem,
  CustomizationHeaderPreset,
  CustomizationIconsStyle,
  CustomizationLinksStyle,
  CustomizationLocale,
  CustomizationSearchStyle,
  CustomizationSidebarBackgroundStyle,
  CustomizationSidebarListStyle,
  CustomizationTheme,
  CustomizationThemedColor,
  CustomizationThemedURL,
  CustomizationThemeMode,
  CustomizationTint,
  SiteCustomizationSettings,
  SiteExternalLinksTarget,
  SiteSpaceCustomizationSettings,
  SiteTitle,
  URL,
} from "./data-contracts";

/**
 * No description
 * @tags site-customization
 * @name GetSiteCustomizationById
 * @summary Get a site customization settings
 * @request GET:/orgs/{organizationId}/sites/{siteId}/customization
 * @secure
 */

// @ts-ignore
export const getSiteCustomizationById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /**
     * (Deprecated) Use the getRawCustomizationSettingsById internal endpoint.
     * @deprecated
     * @default false
     */
    unmasked?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SiteCustomizationSettings;
  ResponseStatusCode: 200 | 400;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/customization",
  method: "get",
  streaming: false,
  tags: ["site-customization"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-customization
 * @name UpdateSiteCustomizationById
 * @summary Update a site customization settings
 * @request PUT:/orgs/{organizationId}/sites/{siteId}/customization
 * @secure
 */

// @ts-ignore
export const updateSiteCustomizationById: {
  route: string;
  method: "put";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: SiteCustomizationSettings;
  RequestHeaders: {};
  ResponseBody: SiteCustomizationSettings;
  ResponseStatusCode: 200 | 400;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/customization",
  method: "put",
  streaming: false,
  tags: ["site-customization"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-customization, internal
 * @name GetSiteRawCustomizationById
 * @summary Get a site raw customization settings
 * @request GET:/orgs/{organizationId}/sites/{siteId}/customization/raw
 * @secure
 */

// @ts-ignore
export const getSiteRawCustomizationById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SiteCustomizationSettings;
  ResponseStatusCode: 200 | 400;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/customization/raw",
  method: "get",
  streaming: false,
  tags: ["site-customization", "internal"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-customization
 * @name GetSiteSpaceCustomizationById
 * @summary Get a site space customization settings
 * @request GET:/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}/customization
 * @secure
 */

// @ts-ignore
export const getSiteSpaceCustomizationById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site-space relationship */
    siteSpaceId: string;
  };
  RequestQuery: {
    /**
     * (Deprecated) Use the getRawCustomizationSettingsById internal endpoint.
     * @deprecated
     * @default false
     */
    unmasked?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SiteCustomizationSettings;
  ResponseStatusCode: 200 | 400;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}/customization",
  method: "get",
  streaming: false,
  tags: ["site-customization"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-customization
 * @name OverrideSiteSpaceCustomizationById
 * @summary Override a site space customization settings
 * @request PATCH:/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}/customization
 * @secure
 */

// @ts-ignore
export const overrideSiteSpaceCustomizationById: {
  route: string;
  method: "patch";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site-space relationship */
    siteSpaceId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** Title to use for the published site variant. If not defined, the title will not be changed. If set to null, the title will be unset and will fallback to the content title. */
    title?: SiteTitle | null;
    styling?: {
      /** The site theme. Set to null to reset the override. */
      theme?: CustomizationTheme | null;
      /** The primary color used for links and UI text. Set to null to reset the override. */
      primaryColor?: CustomizationThemedColor | null;
      /** Used for informational messages and neutral alerts. Set to null to reset the override. */
      infoColor?: CustomizationThemedColor | null;
      /** Used for showing positive actions or achievements. Set to null to reset the override. */
      successColor?: CustomizationThemedColor | null;
      /** Used for showing important information or non-critical warnings. Set to null to reset the override. */
      warningColor?: CustomizationThemedColor | null;
      /** Used for destructive actions or raising attention to critical information. Set to null to reset the override. */
      dangerColor?: CustomizationThemedColor | null;
      /** The tint will color the site’s UI beyond links and buttons, such as header, sidebar and background. By default, the tint colour is the same as your Primary colour, but you can set a custom one too. */
      tint?: CustomizationTint | null;
      /** The style of the corners to use. Set to null to reset the override. */
      corners?: CustomizationCorners | null;
      /** The depth of elements on the site. Set to null to reset the override. */
      depth?: CustomizationDepth | null;
      /** The style for links to use. Set to null to reset the override. */
      links?: CustomizationLinksStyle | null;
      /** The icons style to use for the content. Set to null to reset the override. */
      icons?: CustomizationIconsStyle | null;
      /** Various styles for the sidebar. Each can be Set to null to reset the override. */
      sidebar?: {
        background?: CustomizationSidebarBackgroundStyle | null;
        list?: CustomizationSidebarListStyle | null;
      };
      /** Styling for the search button at the top of the site. */
      search?: CustomizationSearchStyle | null;
      /** The style of background to use. Set to null to reset the override. */
      background?: CustomizationBackground | null;
    };
    /** @deprecated */
    internationalization?: {
      /** The locale to use for the non-custom elements of the UI. Set to null to reset the override. */
      locale: CustomizationLocale | null;
    };
    /** The favicon to use. Set to null to reset the override. */
    favicon?: CustomizationFavicon | null;
    announcement?: CustomizationAnnouncement;
    header?: {
      /** The theme preset to use. Set to null to reset the override. */
      preset?: CustomizationHeaderPreset | null;
      /** The header logo to use. Set to null to reset the override. */
      logo?: CustomizationThemedURL | null;
      /** The destination to open when visitors click the site title/logo in the header. Set to null to reset the override. */
      primaryLink?: ContentRef | null;
      /** The background color used in the header. Set to null to reset the override. */
      backgroundColor?: CustomizationThemedColor | null;
      /** The color used by the links in the header. Set to null to reset the override. */
      linkColor?: CustomizationThemedColor | null;
      /** The links that are displayed in the header. Set to null to reset the override. */
      links?: CustomizationHeaderItem[] | null;
    };
    footer?: {
      /** The logo displayed in the footer. Set to null to reset the override. */
      logo?: CustomizationThemedURL | null;
      /** The links groups that are displayed in the footer. Set to null to reset the override. */
      groups?: CustomizationFooterGroup[] | null;
      /**
       * The copyright text that is displayed in the footer. Set to null to reset the override.
       * @maxLength 300
       */
      copyright?: string | null;
    };
    themes?: {
      /** The theme mode default value. Set to null to reset the override. */
      default?: CustomizationThemeMode | null;
      /** Should the reader be able to switch between dark and light mode. Set to null to reset the override. */
      toggeable?: boolean | null;
    };
    pdf?: {
      /** If true, PDF export is enabled for the published site. Set to null to reset the override. */
      enabled: boolean | null;
    };
    feedback?: {
      /** If true, feedback gathering is enabled. Set to null to reset the override. */
      enabled: boolean | null;
    };
    git?: {
      /** Whether the published site should show a link to edit the content on the git provider set up in the Git Sync. Set to null to reset the override. */
      showEditLink: boolean | null;
    };
    externalLinks?: {
      /** How external links should open. Set to null to reset the override. */
      target: SiteExternalLinksTarget | null;
    };
    pagination?: {
      /** Whether the pagination navigation should be displayed on pages. Set to null to reset the override. */
      enabled: boolean | null;
    };
    trademark?: {
      /** Whether the GitBook trademark ("Powered by GitBook") should be visible. Set to null to reset the override. */
      enabled: boolean | null;
    };
    privacyPolicy?: {
      /** The custom link to the privacy policy. Set to null to reset the override. */
      url?: URL | null;
    };
    socialPreview?: {
      /** The URL for the social preview image. Set to null to reset the override. */
      url?: URL | null;
    };
  };
  RequestHeaders: {};
  ResponseBody: SiteCustomizationSettings;
  ResponseStatusCode: 200 | 400;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}/customization",
  method: "patch",
  streaming: false,
  tags: ["site-customization"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-customization
 * @name DeleteSiteSpaceCustomizationById
 * @summary Delete a site space customization settings
 * @request DELETE:/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}/customization
 * @secure
 */

// @ts-ignore
export const deleteSiteSpaceCustomizationById: {
  route: string;
  method: "delete";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site-space relationship */
    siteSpaceId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205 | 400;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}/customization",
  method: "delete",
  streaming: false,
  tags: ["site-customization"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags site-customization, internal
 * @name GetSiteSpaceRawCustomizationById
 * @summary Get a site space raw customization settings
 * @request GET:/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}/customization/raw
 * @secure
 */

// @ts-ignore
export const getSiteSpaceRawCustomizationById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
    /** The unique id of the site-space relationship */
    siteSpaceId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SiteSpaceCustomizationSettings;
  ResponseStatusCode: 200 | 400;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/site-spaces/{siteSpaceId}/customization/raw",
  method: "get",
  streaming: false,
  tags: ["site-customization", "internal"],
  criticalityLevel: "low",
  deprecated: false,
};
